<template>
  <div class="enterpriseHeader">
    <div class="headerleft">
      <img :src="$headLogo" alt="$headLogo" class="logo" :onerror="`this.src='${$defaultHeadLogo}'`">
    </div>
    <div class="headerlright">
      <el-popover placement="end" width="50" trigger="hover" popper-class="enterpriseLogoutStyle">
        <div>
          <div style="height: 36px;margin-top: 5px;line-height: 36px;text-align: center;" class="pers" @click="gopers">
            <img :src="pers" alt style="vertical-align: text-bottom; margin-right: 5px" />
            <span style="vertical-align: top">用户中心</span>
          </div>
          <div v-if="isShowMyEnterprise" style="height: 36px;margin-top: 5px;line-height: 36px;text-align: center;" class="pers" @click="goMyEnterprise">
            <img :src="convert" alt style="vertical-align: text-bottom; margin-right: 5px" />
            <span style="vertical-align: top">切换企业</span>
          </div>
          <div style="height: 36px;margin-top: 5px;line-height: 36px;text-align: center;margin-bottom: 5px;" class="out" @click="logOut">
            <img :src="out" alt style="vertical-align: text-bottom; margin-right: 5px" />
            <span style="vertical-align: top">退出登录</span>
          </div>
        </div>
        <div slot="reference">
          <img v-if="toxsrc" :src="toxsrc" alt class="toxsrc" />
          <div v-else class="toxClass">
            {{ tox }}
          </div>
          <div class="userName">
            {{ userName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import request from "@/CommonDP/service/login-service";
import { gettouxAvatar, getToken } from "@/CommonDP/utils";
import { mapState } from "vuex";
export default {
  data() {
    return {
      tox: "",
      userName: "",
      out: require("@/CommonDP/assets/out1.png"),
      pers: require("@/CommonDP/assets/pers.png"),
      convert: require("@/CommonDP/assets/doc/convert.png"),
      toxsrc: ""
    };
  },
  computed: {
    ...mapState({
      name: (state) => state.user.userInfo.name,
      userInfo: (state) => state.user.userInfo,
      isShowMyEnterprise: (state) => state.projectMg.isShowMyEnterprise
    })
  },
  mounted() {
    this.userName = this.name;
    if (getToken()) {
      this.getUserAvata(this.name);
    }
  },
  methods: {
    async getUserAvata() {
      const res = await request.getUserAvata();
      var img = "";
      if (res.data) {
        img = gettouxAvatar(this.userInfo.userId, getToken());
      } else {
        img = "";
        this.tox = this.name;
      }
      this.toxsrc = img;
    },
    logOut() {
      this.$confirm("是否退出用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request
            .logout()
            .then(() => {
              this.$router.replace("/");
            })
            .catch(() => {});
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消" });
        });
    },
    gopers() {
      this.$router.push({ name: "userCneter" });
    },
    goMyEnterprise() {
      this.$router.push({ name: "myEnterprise" });
    }
  }
};
</script>
<style lang="scss" scoped>
.enterpriseHeader {
  .headerleft {
    float: left;
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 10px;
    box-sizing: border-box;
    .logo{
      height: 40px;
      object-fit: scale-down;
    }
  }
  .headerlright {
    float: right;
    margin-right: 25px;
    margin-top: 15px;
  }
  .toxsrc {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 0 auto;
    margin-top: 0px;
    display: inline-block;
    vertical-align: top;
  }
  .toxClass {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 0 auto;
    margin-top: 0px;
    border: 1px solid #4777e7;
    background: #4777e7;
    color: #fff;
    display: inline-block;
    vertical-align: top;
    font-size: 16px;
    margin-right: 5px;
  }
  .userName {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    vertical-align: top;
    color: var(--key-color);
    font-size: 12px;
  }
}
</style>
<style lang="scss">
.enterpriseLogoutStyle {
  right: 3px !important;
  top: 58px !important;
  min-width: 120px !important;
  padding: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  position: fixed !important;
  cursor: pointer !important;
  // height: 137px !important;
}
.enterpriseLogoutStyle .pers:hover {
  background: #5584ff1c;
}
.enterpriseLogoutStyle .out:hover {
  background: #5584ff1c;
}
</style>
